import styled from 'styled-components';
const ResultListStyled = styled.div`
  margin-top: 4px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  .export-wrapper {
    margin: 16px 0;
    padding-left: 32px;
    height: 34px;
    .export {
      width: 80px;
      color: #fff;
      .MuiSvgIcon-root {
        margin-right: 8px;
      }
    }
  }
`;
export default ResultListStyled;
